import { React } from "react";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";

const IpsDeficiencyGroupAdminTable = ({ setItemObj, handleShow, data }) => {
  const columns = [
    {
      Header: "Group ID",
      accessor: "groupId",
      width: 50
    },
    {
      Header: "Name",
      accessor: "groupName"
    },
    {
      Header: "Description",
      accessor: "groupDescription"
    },
    {
      Header: "Group Points",
      accessor: "groupPoints",
      width: 50
    },
    {
      Header: "",
      accessor: "edit",
      width: 75,
      Cell: (row) => (
        <div className='text-center'>
          <span
            className='m-2 hyperlink'
            onClick={() => {
              setItemObj(row.row.original);
              handleShow("edit");
            }}
          >
            Edit
          </span>
          <span
            className='m-2 hyperlink'
            onClick={() => {
              setItemObj(row.row.original);
              handleShow("delete");
            }}
          >
            Delete
          </span>
        </div>
      )
    }
  ];

  return data ? (
    <DtsReactTable
      data={data}
      columns={columns}
      showGlobalFilter
      headerColor='ddw'
      cypressid='ipsDeficiencyGroupAdminTable'
    />
  ) : (
    ""
  );
};

export default IpsDeficiencyGroupAdminTable;
